import { useLayoutEffect, useState } from 'react';

function useIsMobile(mobileThreshold = 640) {
  const [width, setWidth] = useState();

  useLayoutEffect(() => {
    function updateWidth() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', updateWidth);
    updateWidth();
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  return width <= mobileThreshold;
}

export default useIsMobile;
